import { Address, Customer } from '../types/models'
import { CartItem, PriceOption } from '../types/Product'
import { CountryCode, Currency, supportedCurrencies } from '../types/locale'

export const TO_CENTS = 100

export function getCartItemPrice(item: CartItem, currency: Currency) {
  const priceOptions = parsePriceOptions(item.metadata.priceOptions)
  return (
    priceOptions.find((option) => option.currency === currency)?.decimalPrice ??
    0
  )
}

export function calculateSubtotalAmount(
  cartItems: CartItem[],
  currency: Currency,
) {
  let subtotal = 0

  for (const item of cartItems) {
    const itemPrice = getCartItemPrice(item, currency)
    subtotal += itemPrice * item.quantity
  }

  return subtotal
}

export function parsePriceOptions(input: unknown): PriceOption[] {
  const priceOptions: PriceOption[] = []

  // Catches null or undefined.
  // eslint-disable-next-line eqeqeq
  if (input == undefined || typeof input !== 'string') {
    return priceOptions
  }

  const parsedJson: unknown = JSON.parse(input)
  if (parsedJson && Array.isArray(parsedJson)) {
    for (const option of parsedJson as unknown[]) {
      if (
        option instanceof Object &&
        'decimalPrice' in option &&
        typeof option.decimalPrice === 'number' &&
        'currency' in option &&
        typeof option.currency === 'string' &&
        supportedCurrencies.includes(option.currency.toUpperCase() as Currency)
      ) {
        priceOptions.push({
          decimalPrice: option.decimalPrice,
          currency: option.currency.toUpperCase() as Currency,
        })
      }
    }
  }

  return priceOptions
}

export function calculateShippingAmount(
  cartItems: CartItem[],
  countryCode: CountryCode,
): number {
  const shippingCostField = `Shipping_Cost_${countryCode}`

  let shippingTotal = 0

  for (const item of cartItems) {
    if (item.metadata[shippingCostField]) {
      shippingTotal += Number(item.metadata[shippingCostField]) * item.quantity
    }
  }

  return shippingTotal
}

export function isAddress(input: unknown): input is Address {
  return (
    input != null &&
    typeof input === 'object' &&
    'addressLine1' in input &&
    'postalCode' in input &&
    'city' in input &&
    'state' in input &&
    'country' in input
  )
}

export function isCustomer(input: unknown): input is Customer {
  return (
    input != null &&
    typeof input === 'object' &&
    'firstName' in input &&
    'lastName' in input &&
    'email' in input &&
    'phone' in input &&
    'companyName' in input
  )
}

export function getCountry(hostname: string): CountryCode {
  if (hostname.endsWith('.ca')) {
    return 'CA'
  } else {
    return 'US'
  }
}

export function calculateCartQuantity(cartItems: CartItem[]): number {
  let itemQuantity = 0
  for (const item of cartItems) {
    itemQuantity += item.quantity
  }
  return itemQuantity
}
